import { Box, Stack } from '@mui/material';

import { SkeletonBlock } from '@mopla/ui';

export const TicketCardSkeleton = () => {
	return (
		<Box
			data-testid="ticket-card-skeleton"
			sx={{
				width: '100%',
				boxSizing: 'border-box',
				display: 'flex',
				alignItems: 'center',
				gap: 1,
				padding: '12px',
				borderRadius: '8px',
				backgroundColor: (theme) => theme.palette.neutral?.main ?? '#FFFFFF',
				border: (theme) =>
					`0.5px solid ${theme.palette.solutions?.[600] ?? '#66758F'}`,
			}}
		>
			<Stack flex={1} gap={0.5}>
				<SkeletonBlock w="40%" h={16} r={6} />
				<SkeletonBlock w="60%" h={14} r={6} />
			</Stack>
			<SkeletonBlock w={24} h={24} r={6} />
		</Box>
	);
};
